import { createContext } from "react"
import type { AuthSession } from "@/types"

export interface AuthContextValue {
  session: AuthSession | null
  isLoading: boolean
  error: string | null
  /** @deprecated Sign-in is handled by Clerk components. */
  loginWithGoogle: (credential: string) => Promise<void>
  /** @deprecated Sign-in is handled by Clerk components. */
  loginWithPassword: (email: string, password: string) => Promise<void>
  /** @deprecated Sign-in is handled by Clerk components. */
  signupWithPassword: (email: string, password: string, displayName?: string) => Promise<void>
  logout: () => Promise<void>
}

/**
 * Legacy context kept for features that read it directly. ClerkAuthBridge
 * provides the value (backed by Clerk + /me); there is no AuthProvider any more.
 */
export const AuthContext = createContext<AuthContextValue | null>(null)
